import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import connect from '../../views/axios/axios.auth';
import Card from '../card.component';
import Modal from '../modal/modal.component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import {
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import utils from '../../utils/utils.functions';
import { useHistory } from 'react-router-dom';


const customStyles = {
rows: {
  style: {
    minHeight: '72px', // override the row height
  }
},
headCells: {
  style: {
    paddingLeft: '8px', // override the cell padding for head cells
    paddingRight: '8px',
  },
},
cells: {
  style: {
    paddingLeft: '8px', // override the cell padding for data cells
    paddingRight: '8px',
  },
},
};

const ProductSearchModal = ({ onSelected, visibleOpen, onClose, backDrop = true, isGuide = false, isReserve = false}) => {
  
  const history = useHistory();
  const [listado, setListado] = useState([]);
  const [pending, setPending] = useState(true);
  const [visible, setVisible] = useState(visibleOpen);
  const [load, setLoad] = useState(false);

  useEffect(() => {
   if (visible) {
    const listadoData = () => {
        connect.get(`/productos/`)
        .then((response) => {
            let productsValue = [];
            response.data.productos.forEach(item => {
              if (!isGuide) {
                if (item.estado && (!item.is_guide && !item.is_reserve)) {
                    productsValue.push(item);
                }
              } else {
                  if (item.estado || item.is_reserve) {
                    productsValue.push(item);
                  }
              }
          });

            if (isGuide) {
              productsValue.unshift(productsValue.splice(productsValue.findIndex(item => item.is_guide), 1)[0])
            }

            setLoad(true);
            setListado(productsValue);
            setPending(false);
        })
    }

    listadoData();
   }
  },[visible])

  useEffect(() => {
    setVisible(visibleOpen);
  },[visibleOpen])

  const clientesSeleccionados = (row) => {
    onSelected(row);
  }

  const columnsClientes = [
    {
      name: 'Producto',
      selector: 'nombre_producto',
      sortable: true,
      wrap: true,
    },
    {
      name: 'Precio/U',
      selector: 'costo',
      sortable: true,
      right: true,
      cell: row => (
          `$${utils.formatMoney(row.costo)}`
      )
    },
    {
      name: 'Seleccionar',
      sortable: false,
      right: true,
      cell: row => (
        <button 
          onClick={() => clientesSeleccionados(row)}
          type="button"
          className="btnx btnx-warn m-1"
        >
            <FontAwesomeIcon icon={faCheck} />
        </button>
      )
    },
  ];

  const goproductos = () => {
    history.push('/ventas/productos');
  }
  
  return (
    <>
    <Modal show={visible} backDrop={backDrop}>
      <Card>
          <h3>Productos</h3>
        
        {!listado.length && load && !isGuide ? 

            <div className="non-products">
                 <button 
                    onClick={goproductos}
                    type="button"
                    className="btnx btnx-warn mr-1"
                  >
                      Agregar nuevos productos
                  </button>
            </div>
        
         :
            <DataTableExtensions
            columns={columnsClientes}
            data={listado}
            export={false}
            print={false}
            filterPlaceholder="Buscar producto"
            >
              <DataTable
                noHeader={true}
                customStyles={customStyles}
                dense={true}
                pagination={true}
                paginationPerPage={5}
                progressPending={pending}
                progressComponent={
                  <h3>Cargando...</h3>
                }
                noDataComponent={"No existen datos asociados a la busqueda."}
              />
            </DataTableExtensions>
          }
          <button 
              onClick={() => onClose()}
              type="button"
              className="btnx btnx-warn mr-1"
              >
                  Cerrar
          </button>
        </Card>
      </Modal>
   </>
  )
}

export default ProductSearchModal;